module.exports = __webpack_public_path__ + "static/media/AdobeStock_306949286.bf43b6c5.jpg";